import React from 'react';

import { useTheme } from '@material-ui/core/styles';

const TourArrow = ({ base, placement, size }) => {
  const theme = useTheme();
  const [side] = placement.split('-');
  const vertical = side === 'top' || side === 'bottom';
  const transforms = {
    bottom: undefined,
    top: `translate(${base} ${size}) rotate(180)`,
    left: `translate(${size} 0) rotate(90)`,
    right: `translate(0 ${base}) rotate(-90)`,
  };
  // Overlap the box by one pixel to prevent a seam at the arrow's base.
  const outline = `M 0 ${size + 1} L ${base / 2 - 2} 2 Q ${base / 2} 0 ${base / 2 + 2} 2 L ${base} ${size + 1}`;

  return (
    <svg
      width={vertical ? base : size}
      height={vertical ? size : base}
      style={{ display: 'block', overflow: 'visible' }}
      aria-hidden="true"
      focusable="false"
    >
      <g transform={transforms[side]}>
        <path d={`${outline} Z`} fill={theme.palette.white.main} />
      </g>
    </svg>
  );
};

export default TourArrow;
